const PREFIX = 'LOCATIONS';

export const LIST_LOCATIONS = `${PREFIX}/LIST`;
export const RETRIEVE_LOCATION = `${PREFIX}/RETRIEVE`;
export const CREATE_LOCATION = `${PREFIX}/CREATE`;
export const UPDATE_LOCATION = `${PREFIX}/UPDATE`;
export const SET_FILTER_LOCATION = `${PREFIX}/SET_FILTER`;
export const DROPDOWN_LOCATIONS = `${PREFIX}/DROPDOWN`;
